import { OrganizationSubjects } from '@/enums/OrganizationSubjects'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import router from '@/router'
import { ApplicationTypes } from '@/common/enums/ApplicationTypes';
import Vessel from '@/common/classes/Vessel';
import moment from 'moment';

const defaultState = {
  organization: {
    subject_id: OrganizationSubjects.Entity,
    name: null,
    inn: null,
    position_of_manager: null,
    director_name: null,
    phone: '',
    innControlSumErr: false,
    innError: false
  },
  application: {
    id: null,
    port: null,
    direction: null,
    sail_type: null,
    planed_date: null,
    actual_date: null,
    cost: 0
  },
  vessel: new Vessel(),
  vesselsList: [],
  portsList: [],
  portSailTypeCost: [],
  sailTypeList: [],
  isNewVessel: false
}

export default {
  namespaced: true,
  state: { ...defaultState },

  mutations: {
    resetState (state) {
      Object.assign(state, defaultState)
    },

    setVessel (state, payload) {
      if (payload === null) {
        payload = new Vessel()
      } else {
        payload = new Vessel({ ...state.vessel, ...payload })
      }

      state.vessel = payload
    },

    clearVessel (state) {
      state.vessel = new Vessel()
    },

    setIsNewVessel (state, payload) {
      state.isNewVessel = !!payload
    },

    setApplication (state, payload) {
      state.application = { ...state.application, ...payload }
    },

    setOrganization (state, payload) {
      state.organization = { ...state.organization, ...payload }
    },

    setVesselsList (state, payload) {
      state.vesselsList = payload ?? []
    },

    setPortsList (state, payload) {
      state.portsList = payload ?? []
    },

    setPortSailTypeCost (state, payload) {
      state.portSailTypeCost = payload ?? []
    },

    setSailTypeList (state, payload) {
      state.sailTypeList = payload ?? []
    }
  },

  actions: {
    async requestApplication (context, payload) {
      await ApiClient.applicationData(payload).then((response) => {
        if (response.status !== 200) {
          router.push('/')

          return
        }

        const responseData = response.data
        const applicationData = responseData.data
        if (applicationData) {
          context.commit('setOrganization', applicationData.organization)
          context.commit('setApplication', applicationData.application)
          context.commit('setVessel', new Vessel(applicationData.vessel))
        }
      })
    },

    async requestExtraData (context, payload) {
      await ApiClient.extraApplicationData({ ...payload, type: ApplicationTypes.SHIP_CALL }).then((response) => {
        if (response.status !== 200) {
          console.log('Request failed.', response);
        }

        const responseData = response.data
        const extraData = responseData.data

        context.commit('setVesselsList', extraData.vesselsList)
        context.commit('setPortsList', extraData.portsList)
        context.commit('setPortSailTypeCost', extraData.portSailTypeCost)
        context.commit('setSailTypeList', extraData.sailTypeList)
      })
    }
  },

  getters: {
    showPreloader (state) {
      return state.showPreloader
    },

    applicationCost (state) {
      let prices = state.portSailTypeCost
        ?.filter(x => x.port_id === state.application.port && x.sail_type_id === state.application.sail_type)
      const fallBackPrices = prices?.filter(x => x.begin_at === undefined) // цены из таблицы PortSailType
      prices = prices?.filter(x => x.begin_at !== undefined && moment(x.begin_at) <= moment(state.application.planed_date, 'DD.MM.YYYY') && moment(x.expired_at) >= moment(state.application.planed_date, 'DD.MM.YYYY')) // цены из таблицы PaymentBaseTariff
      if (prices.length === 0) {
        prices = fallBackPrices;
      }

      const price = prices?.[0]

      return (state.vessel.tonnage * price?.cost).toFixed(2)
    }
  }
}
